null


// WEBPACK FOOTER //
// /Volumes/workplace/commands/BatchDetectEntitiesCommand.ts